<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          {
            name: 'SubCategories',
            to: {
              name: 'SubCategories'
            }
          },
          {
            name: 'SubCategory Info',
            to: {
              name: 'SubCategoryInfo',
              params: {
                id: $route.params.id
              }
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'SubCategoryInfoEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>編輯子分類</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!--  -->
    <SubCategoryEditCreate></SubCategoryEditCreate>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SubCategoryEditCreate from '@/views/C-2__SubCategory/c/SubCategoryEditCreate.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    SubCategoryEditCreate,
    Breadscrumbs,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('subcategory', ['subcategory']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getSubCategory(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('subcategory', {
      getSubCategory: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.clear();
      this.$router.push({ name: 'SubCategories' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (this.isLangOpen || !this.lang.id) {
          if (!this.subcategory.name) {
            this.errors.push('SubCategory Name required.');
          }
          if (!this.subcategory.bu_id) {
            this.errors.push('BU required.');
          }
          if (!this.subcategory.product_category_id) {
            this.errors.push('Category required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.subcategory).then(() => {
            this.clear();
            this.$router.push({ name: 'SubCategories' });
          });
        } else {
          this.isLangOpen = true;
        }
      }
    },
  },
};
</script>